module.exports = __webpack_public_path__ + "img/ProductoSinImagen2.9361e709.jpg";